import gatewayService from '@/modules/common/services/gatewayService';

const bulkRoute = 'v3/clients/client_settings/bulk';

const bulkUpdate = async (clientSettings) => gatewayService
  .put(bulkRoute, { client_settings: clientSettings })
  .then((res) => res.data?.data);

export default {
  bulkUpdate,
};
